// eslint-disable-next-line
import React, { useState, useEffect } from 'react';
// eslint-disable-next-line
import styles from './InstallPrompt.module.css';
import { authenticatedFetch } from '../../utils/api';

const InstallPrompt = ({ show, onClose }) => {
    const [deferredPrompt, setDeferredPrompt] = useState(null);
    const [isInstallable, setIsInstallable] = useState(false);

    useEffect(() => {
        const handleBeforeInstallPrompt = (e) => {
            e.preventDefault();
            setDeferredPrompt(e);
            setIsInstallable(true);
        };

        window.addEventListener('beforeinstallprompt', handleBeforeInstallPrompt);

        const isStandalone = window.matchMedia('(display-mode: standalone)').matches;
        if (isStandalone) {
            setIsInstallable(false);
        }

        return () => {
            window.removeEventListener('beforeinstallprompt', handleBeforeInstallPrompt);
        };
    }, []);

    const trackInstallation = async () => {
        try {
            await authenticatedFetch('/api/auth/track-pwa-install', {
                method: 'POST'
            });
        } catch (error) {
            console.error('Failed to track installation:', error);
        }
    };
    // eslint-disable-next-line
    const handleInstallClick = async () => {
        if (!deferredPrompt) return;

        deferredPrompt.prompt();

        try {
            const { outcome } = await deferredPrompt.userChoice;
            if (outcome === 'accepted') {
                await trackInstallation();
                setIsInstallable(false);
            }
        } catch (error) {
            console.error('Installation failed:', error);
        } finally {
            setDeferredPrompt(null);
            onClose();
        }
    };
    // eslint-disable-next-line
    const handleDismiss = () => {
        onClose();
        localStorage.setItem('pwa_prompt_dismissed', Date.now().toString());
    };

    if (!show || !isInstallable) return null;

    return (
        null
        // <div className={styles.promptContainer}>
        //     <div className={styles.promptContent}>
        //         <div className={styles.iconContainer}>
        //             <div className={styles.promptIcon}>
        //                 <img src="/logo512.png" alt="TopSpeaks" />
        //             </div>
        //             <div className={styles.promptText}>
        //                 <h4>Install TopSpeaks</h4>
        //                 <p>Access your AI presentation coach instantly from your desktop for seamless practice sessions.</p>
        //             </div>
        //         </div>
        //         <div className={styles.promptActions}>
        //             <button
        //                 className={styles.installButton}
        //                 onClick={handleInstallClick}
        //             >
        //                 Install Now
        //             </button>
        //             <button
        //                 className={styles.dismissButton}
        //                 onClick={handleDismiss}
        //             >
        //                 Not Now
        //             </button>
        //         </div>
        //     </div>
        // </div>
    );
};

export default InstallPrompt;